import { render, staticRenderFns } from "./ProfileCompanySettings.vue?vue&type=template&id=2048078a&scoped=true"
import script from "./ProfileCompanySettings.vue?vue&type=script&lang=js"
export * from "./ProfileCompanySettings.vue?vue&type=script&lang=js"
import style0 from "./ProfileCompanySettings.vue?vue&type=style&index=0&id=2048078a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2048078a",
  null
  
)

export default component.exports